<nz-spin [nzSpinning]="loading">
  <div class="wmsm-box">
    <nz-card >
    <div class="查询条件">
      <form nz-form [formGroup]="validateForm">
        <!-- 第一行 -->
        <div nz-row>
          <div nz-col nzSpan="2">
            <nz-form-label>
              <div class="width-100-percent label-font">
                {{ "Site" | translate }}
              </div>
            </nz-form-label>
            <nz-form-item>
              <nz-form-control nzSpan="20">
                <nz-select formControlName="Site" nzAllowClear    nzPlaceHolder="{{'ALL'|translate}}">
                  <nz-option *ngFor="let option of SiteList" [nzLabel]="option" [nzValue]="option" >
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>


          <div nz-col nzSpan="4">
            <nz-form-label>
              <div class="width-100-percent label-font">
                {{ "VendorCode" | translate }}
              </div>
            </nz-form-label>
            <nz-form-item>
              <nz-form-control nzSpan="22">
                <input nz-input formControlName="VendorCode" />
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col   class="row-with-spacing-button">
            <button nz-button class="default-button" nzType="primary" (click)="onSearch()">
              <span nz-icon nzType="search"></span>
              {{ "Query" | translate
            }}</button>
          </div>

          <div nz-col   class="row-with-spacing-button">
            <button nz-button nzType="primary" class="default-button"
              (click)="exportTableToExecl()">
              <span nz-icon nzType="export" nzTheme="outline"></span>
              {{"DownloadExcel"|translate}}</button>
          </div>
        </div>
        <!-- 第二行 -->
        <!-- <div nz-row>

          <td><nz-form-label>{{"VendorCode"|translate}}</nz-form-label></td>
          <td><nz-form-control><input nz-input formControlName="VendorCode" style="width: 200px;" /></nz-form-control>
          </td>
          <td nz-col class="width-100-percent">
            <button nz-button class="default-button" nzType="primary" (click)="onSearch()">{{ "Query" | translate
              }}</button>


        </div> -->
      </form>
    </div>
  </nz-card>
  <nz-card style="margin-top: 10px;">
    <div >
      <strong class="margin-left-8 result">{{ "Results" | translate}}({{nzTotal}})</strong>
    </div>
    <div class="表格" style="width: 100%;">
      <nz-table #colSpanTable [nzData]="listOfData" nzSize="middle" nzShowSizeChanger [nzFrontPagination]="false"
        [nzShowPagination]='false' [nzPageSize]='pageSize' [nzPageIndex]='pageIndex'
        [nzScroll]="{ y: '720px',x:'1000px' }">
        <thead>
          <tr>

            <th scope="col">{{ "Lock" | translate}}</th>
            <th scope="col">{{ "Site" | translate}}</th>
            <th scope="col">{{ "table.VendorCode" | translate}}</th>
            <th scope="col">{{ "table.VendorName" | translate}}</th>
            <th scope="col">{{ "ExcludeVendorReason" | translate}}</th>
            <th scope="col" nzWidth="150px" [nzRight]="true" style="text-align:center;">{{ "DownloadSupportiveFiles" | translate}}</th>
            <th scope="col" nzWidth="100px" [nzRight]="true" style="text-align:center;">{{ "act" | translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of colSpanTable.data;let i=index">
          
            <!-- <td><img src="../../../assets/image/img_edit.png" [alt]="'Button.Update'|translate" (click)="onEdit(data)"
                class="pointer"></td> -->
            <td>{{data.lock}}</td>
            <td>{{data.site}}</td>
            <td>{{data.vendorCode}}</td>
            <td>{{data.vendorName}}</td>
            <td>{{data.excludeVendorReason}}</td>
            <td [nzRight]="true" style="text-align:center;">
              <span nz-icon nzType="file" nzTheme="twotone" (click)="GetFileTokenOnClick(data)" *ngIf="data.proofFile" style="font-size: 20px;cursor: pointer;" nz-tooltip nzTooltipTitle="{{data.vendorCode}}"></span>
               <!-- <a *ngIf="data.proofFile " nz-button nzSize='Large' nzType="link"
                (click)="GetFileTokenOnClick(data)">Link</a> -->
            </td>
            <td [nzRight]="true" style="text-align: center;"><span nz-icon nzType="edit" nzTheme="twotone" (click)="onEdit(data)" style="font-size: 20px; cursor: pointer;" ></span></td>
          </tr>
        </tbody>
      </nz-table>
      <!-- <nz-pagination style="float:right;" [(nzPageIndex)]="pageIndex" [nzTotal]="nzTotal" [nzSize]="'small'" nzShowSizeChanger
    [nzPageSizeOptions]="[10, 15, 20]" [nzPageSize]='pageSize' (nzPageSizeChange)="nzPageSizeChange($event)" nzShowQuickJumper
    (nzPageIndexChange)="nzPageIndexChange($event)"></nz-pagination> -->

      <nz-pagination style="float:right;" [(nzPageIndex)]="pageIndex" [nzTotal]="nzTotal" [nzSize]="'small'"
        nzShowSizeChanger [nzPageSize]='pageSize' (nzPageSizeChange)="nzPageSizeChange($event)" [nzPageSizeOptions]="[10, 20, 50,100]"
        (nzPageIndexChange)="nzPageIndexChange($event)" [nzItemRender]="renderItemTemplate"></nz-pagination>
        

      <ng-template #renderItemTemplate let-type let-page="page" >

        <a *ngIf="type === 'page'">{{ page }}</a>
        <a *ngIf="type === 'prev'" [style.color]="'black'">&#60;</a>
        <a *ngIf="type === 'next'" [style.color]="'black'">&#62;</a>
      </ng-template>
    </div>
  </nz-card>
    <!-- <div class="按钮区">
      <div style="margin-top: 20px">
        <div nz-row nzGutter="64">
          <div nz-col>
            <button nz-button nzType="primary" class="default-button"
              (click)="exportTableToExecl()">{{"DownloadExcel"|translate}}</button>
          </div>
        </div>
      </div>
    </div> -->

    <app-edit-excludevendor *ngIf="isEdit" [isEdit]="true" [editData]="editData" (close)="closeEdit()"
      (save)="saveEdit($event)"></app-edit-excludevendor>

  </div>

</nz-spin>